
@switch (isMobile$ | async) {
  <!-- MOBILE FOOTER -->
  @case (true) {
    <footer-mobile
      [primary]="primary"
      (primaryClicked)="primaryClick()"
      [primLoading]="primLoading"
      [primDisabled]="primDisabled"
      [primCenteredIfNoSecondary]="primCenteredIfNoSecondary"
      [secondary]="secondary"
      (secondaryClicked)="secondaryClick()"
      [secLoading]="secLoading"
      [secDisabled]="secDisabled"
      [hidden]="hidden"
      [valid]="valid"
    ></footer-mobile>
  }
  <!-- DESKTOP FOOTER -->
  @case (false) {
    <footer-desktop
      [layout]="layout"
      [primary]="primary"
      (primaryClicked)="primaryClick()"
      [primLoading]="primLoading"
      [primDisabled]="primDisabled"
      [secondary]="secondary"
      (secondaryClicked)="secondaryClick()"
      [secLoading]="secLoading"
      [secDisabled]="secDisabled"
    ></footer-desktop>
  }
}
